import { render } from "./partnerSelector.vue?vue&type=template&id=4a473a42"
import script from "./partnerSelector.vue?vue&type=script&lang=js"
export * from "./partnerSelector.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__